var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.1 91.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6,5c22.3,0,40.5,18.2,40.6,40.6C86.2,68,68,86.2,45.6,86.2S5,68,5,45.6S23.2,5,45.6,5 M45.6,0C20.4,0,0,20.4,0,45.6 s20.4,45.6,45.6,45.6s45.6-20.4,45.6-45.6C91.1,20.4,70.7,0,45.6,0L45.6,0z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3,28.3L62.3,28.3L62.3,28.3c-0.3-4.2-2.1-8.2-5.2-11.2c-3-3-7-4.8-11.2-5l0,0l0,0c-0.3,0-0.6,0-0.8,0 c-4.5,0-8.7,1.7-11.9,4.8c-3.4,3.3-5.3,7.7-5.3,12.5c0,3.2,2.3,5.8,5.3,6.4l0.3,0.1h1c3.6,0,6.5-2.9,6.5-6.5c0-1.2,0.4-2.2,1.2-3 c0.8-0.8,1.8-1.2,2.9-1.2c0.1,0,0.1,0,0.2,0c2.1,0.1,3.8,1.8,3.9,3.9c0.1,1.5-0.6,2.9-1.8,3.8C41.8,37,38.5,43.4,38.5,50v0.4 c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5V50c0-2.6,1.3-4.9,3.5-6.5l0,0l0,0C60,40,62.6,34.3,62.3,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,61.3c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1s8.1-3.6,8.1-8.1C53.1,64.9,49.5,61.3,45,61.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.1f2cfb7657b1106135e6ef2bc2c74e4e.svg";
export { ForwardRef as ReactComponent };